import { createSlice } from "@reduxjs/toolkit";
import { IBasket } from "../interface/IBasket";

const initialState : IBasket | null = null;

const basket = createSlice({
 name: "basket",
 initialState,
 reducers: {
   setBasketInStore: (state, action) => {
     return action.payload;
   },
   clearBasketInStore: (state) => {
     return initialState;
   },
 },
});

export const { setBasketInStore, clearBasketInStore } = basket.actions;

export default basket.reducer;
